import React from "react";
import { Link } from "react-router-dom";

import Form from "../elements/Form";
import SigningFormHead from "./SigningFormHead";

import FlexRowReverse from "../../ui/FlexRowReverse";
import HalfPage from "../../ui/HalfPage";
import Button from "../../ui/Button";
import { isForgetPassword } from "../../../services/defaultSettings";
import { motion } from "framer-motion";

const SigningForm = ({
    headTitle,
    headIcon,
    picture,
    description,
    onSubmit,
    fields,
    color,
    secondaryColor,
    buttonTitle,
    altLink,
    alt = false,
    altColored,
    className = "",
    isLoading = false,
    toSpin = false,
    alternative = false,
    halfPageClassName = "",
    isPBMargin = true,
    showForgetPassword = false,
    aboveDescription = "",
    afterLogin = "",
    handlePasswordForget = () => null,
    layout = "default",
}) => {
    let altClassName = `text-teal-600 dark:text-teal-300`;
    if (secondaryColor === "cyan") {
        altClassName = `text-cyan-600 dark:text-cyan-300`;
    } else if (secondaryColor === "rose") {
        altClassName = `text-rose-600 dark:text-rose-300`;
    } else if (secondaryColor === "yellow") {
        altClassName = `text-yellow-600 dark:text-yellow-300`;
    } else if (secondaryColor === "purple") {
        altClassName = `text-purple-600 dark:text-purple-300`;
    } else if (secondaryColor === "emerald") {
        altClassName = `text-emerald-600 dark:text-emerald-300`;
    } else if (secondaryColor === "blue") {
        altClassName = `text-blue-500 dark:text-blue-400`;
    } else if (secondaryColor === "sky") {
        altClassName = `text-sky-500 dark:text-sky-400`;
    } else if (secondaryColor === "ashGray") {
        altClassName = `text-ashGray-500 dark:text-ashGray-400`;
    } else if (secondaryColor === "earthYellow") {
        altClassName = `text-earthYellow-500 dark:text-earthYellow-400`;
    } else if (secondaryColor === "germanRed") {
        altClassName = `text-germanRed-500 dark:text-germanRed-400`;
    }
    if (!className.includes("space-y")) {
        className += ` space-y-12`;
    }

    if (layout === "default") {
        return (
            <HalfPage picture={picture} className={halfPageClassName} isPBMargin={isPBMargin}>
                <div className={`w-4/5 h-4/5 flex justify-center lg:px-10 flex-col ${className}`}>
                    {alternative ? (
                        <div>{alternative}</div>
                    ) : (
                        <>
                            <div className="font-h2 font-w-bold relative">
                                <SigningFormHead
                                    title={headTitle}
                                    icon={headIcon}
                                    color={color}
                                    toSpin={toSpin}
                                />
                            </div>
                            {aboveDescription ? aboveDescription : ""}

                            <div className="clr-text-secondary font-normal ">{description}</div>

                            <div className="">
                                <Form onSubmit={onSubmit}>
                                    <div className="space-y-6">
                                        <div>{fields}</div>
                                        <div className="flex">
                                            <Button
                                                type="submit"
                                                isLoading={isLoading}
                                                className="px-20 py-3"
                                                color={color}
                                            >
                                                {buttonTitle}
                                            </Button>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                            {afterLogin ? afterLogin : ""}
                            {showForgetPassword && isForgetPassword ? (
                                <div>
                                    هل نسيت كلمة السر؟{" "}
                                    <span
                                        className="font-w-bold underline cursor-pointer"
                                        onClick={handlePasswordForget}
                                    >
                                        اضغط هنا
                                    </span>
                                </div>
                            ) : (
                                ""
                            )}
                            {alt ? (
                                <FlexRowReverse className="clr-text-secondary font-normal">
                                    <span>{alt}</span>
                                    <Link to={altLink}>
                                        <span className={altClassName}>{altColored}</span>
                                    </Link>
                                </FlexRowReverse>
                            ) : (
                                ""
                            )}
                        </>
                    )}
                </div>
            </HalfPage>
        );
    } else if (layout === "Glassmorphism") {
        return (
            <div className="relative flex space-y-10 py-[5rem] items-center justify-center min-h-screen w-screen ">
                {/* Background Animation with German Theme */}
                <div className="absolute inset-0 overflow-hidden">
                    <motion.div
                        animate={{ y: [0, 15, 0], opacity: [0.6, 0.8, 0.6] }}
                        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
                        className="absolute w-[500px] h-[500px] bg-[#b22222]/20 rounded-full top-10 left-10 filter blur-3xl"
                    />
                    <motion.div
                        animate={{ x: [0, 15, 0], opacity: [0.4, 0.6, 0.4] }}
                        transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
                        className="absolute w-[400px] h-[400px] bg-[#ffcc00]/20 rounded-full bottom-10 right-10 filter blur-3xl"
                    />
                    <motion.div
                        animate={{ x: [-15, 15, -15], opacity: [0.3, 0.5, 0.3] }}
                        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
                        className="absolute w-[450px] h-[450px] bg-[#121212]/30 rounded-full top-1/3 left-1/3 filter blur-3xl"
                    />
                </div>
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                    className="relative w-[80%] max-w-3xl bg-white/10 backdrop-blur-lg shadow-2xl rounded-2xl p-10"
                >
                    <div className="flex-center-both gap-4">
                        <span className={`flex-center-both w-8 ${toSpin && "tospin"}`}>
                            <img src={headIcon} alt="icon" />
                        </span>
                        <h2 className="text-center text-3xl font-bold drop-shadow-lg">
                            {headTitle}
                        </h2>
                    </div>
                    {aboveDescription ? (
                        <p className="text-center text-gray-500 mt-3">{aboveDescription}</p>
                    ) : (
                        ""
                    )}
                    <div className="clr-text-secondary text-center font-normal mt-4 ">
                        {description}
                    </div>

                    <form onSubmit={onSubmit} className="mt-6 space-y-6">
                        <div>{fields}</div>
                        <Button
                            type="submit"
                            isLoading={isLoading}
                            className="px-20 py-3"
                            color={color}
                        >
                            {buttonTitle}
                        </Button>
                    </form>

                    <div className="mt-6 text-center space-y-4">
                        {afterLogin ? afterLogin : ""}
                        {showForgetPassword && isForgetPassword ? (
                            <div>
                                هل نسيت كلمة السر؟{" "}
                                <span
                                    className="font-w-bold underline cursor-pointer"
                                    onClick={handlePasswordForget}
                                >
                                    اضغط هنا
                                </span>
                            </div>
                        ) : (
                            ""
                        )}
                        {alt ? (
                            <FlexRowReverse className="clr-text-secondary font-normal">
                                <span>{alt}</span>
                                <Link to={altLink}>
                                    <span className={altClassName}>{altColored}</span>
                                </Link>
                            </FlexRowReverse>
                        ) : (
                            ""
                        )}
                    </div>
                </motion.div>
            </div>
        );
    }
};

export default SigningForm;
